import { Col, Container, Row } from 'react-bootstrap';
import Services from '../../../Litho/Components/Services/Services';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';

const serviceData = [
	{
		icon: 'line-icon-Truck',
		title: 'FTL (Full Truck Load)',
		content: 'Direct truckload moves for high-volume, time-sensitive freight.',
	},
	{
		icon: 'line-icon-Box-Open',
		title: 'LTL (Less-than-Truckload)',
		content: 'Cost-effective consolidation for smaller shipments.',
	},
	{
		icon: 'line-icon-Location-2',
		title: 'Dedicated Domestic routes',
		content: 'Fixed schedules with guaranteed capacity.',
	},
	{
		icon: 'line-icon-Fog-Night',
		title: 'Express overnight trucking',
		content: 'Expedited pickup and delivery for urgent cargo.',
	},
	{
		icon: 'line-icon-Temperature',
		title: 'Temperature control',
		content: 'Reefer services for perishables and sensitive goods.',
	},
	{
		icon: 'line-icon-Shield',
		title: 'High-value security for valuables',
		content: 'Secure transport and monitored routes.',
	},
];

const ServicesGrid = () => {
	return (
		<section className='bg-lightgray z-[1] relative py-[130px] lg:py-[90px] sm:py-[75px] xs:py-[50px]'>
			<Container>
				<Row className='justify-center'>
					<Col
						md={6}
						className='font-serif justify-center flex flex-col items-center mb-20 sm:mb-12'
					>
						<span className='mb-[10px] inline-block uppercase font-medium text-gradient bg-gradient-to-r from-[#bd3531] to-[#23262d] tracking-[1px]'>
							Comprehensive trucking
						</span>
						<h5 className='text-darkgray font-semibold -tracking-[1px]'>
							Road Freight Services
						</h5>
					</Col>
				</Row>
				<Row className='justify-center'>
					<Col lg={12} md={10} xs={12} className='xs:px-0'>
						<Services
							grid='row-cols-lg-3 row-cols-1 md:my-0 md:mx-auto gap-y-[15px] rounded-full'
							theme='service-style-05'
							className=''
							data={serviceData}
							animation={fadeIn}
						/>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default ServicesGrid;
